import { Link } from "react-router-dom";

export default function SiteIntro() {
  const stats = [
    { value: "30+", label: "收录影视作品" },
    { value: "6", label: "主要演员资料" },
    { value: "100%", label: "剧情深度解析" },
  ];

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line"></i>
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            专业影视内容介绍平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            本站聚焦热门影视剧《善良的嫂子》，为你系统整理剧情梗概、角色设定与演员资料，
            并延伸推荐同类型优质影视作品。无论你是正在追剧的观众，还是想深入了解剧集背后故事的影视爱好者，
            都能在这里快速获取清晰、完整的内容参考。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们专注于内容介绍与解析，不提供任何播放与下载服务，所有信息仅供观剧参考。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/detail/kind-sister-in-law"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center"><i className="ri-play-circle-line"></i></span>
              了解《善良的嫂子》
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              更多介绍
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-4">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`flex flex-col items-center justify-center rounded-lg p-4 text-center md:p-6 ${
                index === 1 ? "bg-accent-100" : "bg-background-50"
              }`}
            >
              <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{stat.value}</span>
              <span className="mt-1 text-xs text-foreground-600 md:text-sm">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}